export const CALENDAR_LINK = 'https://calendly.com/hamnjam/40min?month=2023-02'
export const PAGE_NEWS_COUNT = 6
export const PAGE_PRODUCT_COUNT = 15
export const PAGE_GET_COUNT = 3
export const PAGE_GET_PRODUCT = 3
export const SHARE_URL = 'http://nikita.4steps.am/hy/blog'